import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Route, RouterModule } from '@angular/router';
import { PageComponent } from './page/page.component';
import { BannerComponent } from './components/banner/banner.component';
import { GridsComponent } from './components/grids/grids.component';
import { TargetedStrategiesComponent } from './components/targeted-strategies/targeted-strategies.component';
import { ColorGridComponent } from './components/color-grid/color-grid.component';
import { StoriesComponent } from './components/stories/stories.component';

const routes:Route[] =[
  { path :"", component:PageComponent },
] 

@NgModule({
  declarations: [
    PageComponent,
    BannerComponent,
    GridsComponent,
    TargetedStrategiesComponent,
    ColorGridComponent,
    StoriesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
  ]
})
export class CaseStudyPageModule { }
